import { baseClickGtmEvent, baseScrollGtmEvent } from '@/logic/metrika/constants'
import type { IFormattedGtmEventPayload } from '@/logic/metrika/interfaces'

export enum EJournalScrollEventBlockId {
  scrollEndOfArticle = 'scrollEndOfArticle',
}
export enum EJournalClickEventBlockId {
  listArticles = 'listArticles',
}

export const JournalGtmClickEventPayload: Record<EJournalClickEventBlockId, IFormattedGtmEventPayload> = {
  [EJournalClickEventBlockId.listArticles]: {
    ...baseClickGtmEvent,
    blockName: 'listArticles',
    eventLabel: 'itemArticle',
  },
}

export const JournalGtmScrollEventPayload: Record<EJournalScrollEventBlockId, IFormattedGtmEventPayload> = {
  [EJournalScrollEventBlockId.scrollEndOfArticle]: {
    ...baseScrollGtmEvent,
    eventLabel: 'scrollEndOfArticle',
  },
}
